// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F94u","largestCol":"styles_largestCol__4qA-x","smallestCol":"styles_smallestCol__3OHmK"};